/*
 * @Author: LiuMouLiang
 * @Date: 2021-11-25
 */
/* eslint-disable */
import {
    getObjVal,
    _trim,
    _toJson,
    typeOf,
    regHtmlBreakList,
    getFileExtName,
    setUrlHttps,
    _cloneObj,
    trace as _trace,
    warning as _warning,
    useStateErrorMsg,
    getOneObj,
    _isValue,
    _for,
    _encode,
} from 'tools';
import {
    IS_RELEASE,
    IS_DEV,
    env_isTrace,
    process_env,
    IS_TRIAL,
    PDF_URL,
} from '_libs/host';
import {
    trace,
    warning,
} from './base';

export {
    useStateErrorMsg,
};

/**
 * 获取页面链接参数
 * @param {Array} ignore 可选参数，指定不需要返回的参数键名数组
 * @returns 返回一个对象，包含页面链接中除忽略项外的所有参数
 * nw  == app定义的特殊参数
 * initialSource == 初始来源，一般不用于传值，但支持取值
 * getPageParams([])
 */
export const getPageParams = function(ignore){
    const query = getObjVal(this,'$route.query') || {};
    const params = getObjVal(this,'$route.params') || {};
    let res = Object.assign({}, params, query);
    if(!ignore)  ignore = ['initialSource'];
    return getOneObj(res, ignore);
};

/**
 * @method  $regHtmlBreakList
 * @param   {String}          htmlStr 富文本数据
 * @return  {String}
 *
 * @desc    重置富文本数据
 * @author  liumouliang
 * @date    2022-12-22
 * @example
 *
 * regHtmlBreakList(htmlStr)
 */
export const $regHtmlBreakList = function(htmlStr){
    return htmlStr ? regHtmlBreakList(_trim(htmlStr), '<br />') : '';
};

export const hasDataLength = function (data) {
    return typeOf(data, 'array') && getObjVal(data, 'length');
};

export const get_pdfURL = function(file){
    return PDF_URL + `?file=${_encode(file)}`;
};
export const isPdfUrl = function(url){
    const ext = getFileExtName(url);
    return ext === 'pdf';
};

export const getHandleUrl = function(url){
    if (!url) return false;
    if(isPdfUrl(url)){
        url = get_pdfURL(url);
    }else{
        url = setUrlHttps(url);
    };
    return url;
};
export const handleFile = function(url){
    if (!url) return true;
    url = getHandleUrl(url);
    window.open(url, '_blank');
};

/**
 * 获取职业类型
 * 把职业类型'1' 转换成 '100000'
 * */
export const getJobType = function (val) {
    let jobType = ''
    for (let i = 0; i < 6; i++) {
        if (val == i + 1) {
            jobType += '1'
        } else {
            jobType += '0'
        }
    }
    return jobType
};

/**
 * 获取职业类型number值
 * 把职业类型'100000' 转换成 '1'
 * */
export const getJobTypeVal = function (jobType) {
    let res = 0;
    jobType += '';
    for (let i = 0; i < jobType.length; i++) {
        const str = jobType.substr(i, 1);
        res++;
        if(str == 1) return res;
    }
    return res
};

export const _getQueryForm = function(query){
    let res = {};
    _for(query, (el, key)=>{
        if(_isValue(el)) {
            res[key] = el;
        }
    });
    return res;
};

//获取用户层级根据userTier
export const getLenvelToUserTier = function(userTier){
    let res = '';
    if(typeOf(userTier, 'number')){
        if([2, 3, 6].includes(userTier)) { //是否准A
            res = 'quasiA';
        }else if([4, 5].includes(userTier)) { //是否A
            res = 'isUserA';
        }else if([0, 1, 7].includes(userTier)){ //是否非代理人/C
            res = 'isNoAgentOrC';
        }else{
            res = 'other';
        }
    };
    return res;
};



// WEBPACK FOOTER //
// ./src/libs/util/util.js